import { HEALTH_STATUS } from '@/types/enums/health-status.enum';
import {
  ASSETS_HEALTH_STATUS_ITEMS,
  ASSETS_CONDITION_ITEMS,
  DATA_COVERAGE_ITEMS,
  ASSET_ASSESSABILITY_ITEMS,
  CAMERA_INSTALLED_ITEMS,
} from './filter-options';
import {
  FILTER_LABEL,
  CAMERA_INSTALLED_ID,
  ASSET_ASSESSABILITY_ID,
  ASSETS_CONDITION_ID,
  DATA_COVERAEGE_ID,
  ASSETS_HEALTH_STATUS_ID,
} from './types/filter.enums';
import {
  FILTER_OPTIONS_TYPE,
  FILTER_PLACEMENT,
  FILTER_TYPE,
  FILTER_TRIGGER_TYPE,
  FilterConfig,
} from '@/components/uiKit/FiltersGroup/types';

export const assetsFilterConfig: FilterConfig = [
  {
    allStaticValues: ASSETS_HEALTH_STATUS_ITEMS.map((item) => item.id),
    initialStaticValues: ASSETS_HEALTH_STATUS_ITEMS.map((item) => item.id),
    fieldName: 'health_status',
    fieldValueToFilterValueMapping: (fieldValue: string) => {
      if (fieldValue === HEALTH_STATUS.CRITICAL) return ASSETS_HEALTH_STATUS_ID.CRITICAL;
      if (fieldValue === HEALTH_STATUS.ALARM) return ASSETS_HEALTH_STATUS_ID.ALARM;
      if (fieldValue === HEALTH_STATUS.MONITOR) return ASSETS_HEALTH_STATUS_ID.MONITOR;
      if (fieldValue === HEALTH_STATUS.HEALTHY) return ASSETS_HEALTH_STATUS_ID.HEALTHY;
      return ASSETS_HEALTH_STATUS_ID.NA;
    },
    filterOptionsType: FILTER_OPTIONS_TYPE.STATIC,
    filterData: {
      filterLabel: FILTER_LABEL.ASSETS_HEALTH_STATUS,
      placement: FILTER_PLACEMENT.QUICK,
      filterType: FILTER_TYPE.MULTICHECKBOX,
      triggerType: FILTER_TRIGGER_TYPE.BUTTON,
      triggerProps: {
        variant: 'outline',
        size: 'default',
      },
      filterOptions: ASSETS_HEALTH_STATUS_ITEMS,
    },
  },
  {
    allStaticValues: ASSETS_CONDITION_ITEMS.map((item) => item.id),
    initialStaticValues: ASSETS_CONDITION_ITEMS.map((item) => item.id),
    fieldName: 'health_status_changed',
    filterOptionsType: FILTER_OPTIONS_TYPE.STATIC,
    fieldValueToFilterValueMapping: (fieldValue: boolean) =>
      fieldValue ? ASSETS_CONDITION_ID.STATUS_CHANGED : ASSETS_CONDITION_ID.NO_STATUS_CHANGE,
    filterData: {
      filterLabel: FILTER_LABEL.ASSETS_CONDITION,
      placement: FILTER_PLACEMENT.ADDITIONAL,
      filterType: FILTER_TYPE.MULTICHECKBOX,
      triggerType: FILTER_TRIGGER_TYPE.ACCORDEON,
      filterOptions: ASSETS_CONDITION_ITEMS,
    },
  },
  {
    allStaticValues: DATA_COVERAGE_ITEMS.map((item) => item.id),
    initialStaticValues: DATA_COVERAGE_ITEMS.map((item) => item.id),
    fieldName: 'data_coverage',
    filterOptionsType: FILTER_OPTIONS_TYPE.STATIC,
    fieldValueToFilterValueMapping: (fieldValue: number) => {
      if (fieldValue <= 0.5) return DATA_COVERAEGE_ID.OFFLINE;
      if (fieldValue > 0.8) return DATA_COVERAEGE_ID.ONLINE;
      return DATA_COVERAEGE_ID.SEMI;
    },
    filterData: {
      filterLabel: FILTER_LABEL.DATA_COVERAEGE,
      placement: FILTER_PLACEMENT.ADDITIONAL,
      filterType: FILTER_TYPE.MULTICHECKBOX,
      triggerType: FILTER_TRIGGER_TYPE.ACCORDEON,
      filterOptions: DATA_COVERAGE_ITEMS,
    },
  },
  {
    allStaticValues: ASSET_ASSESSABILITY_ITEMS.map((item) => item.id),
    initialStaticValues: ASSET_ASSESSABILITY_ITEMS.map((item) => item.id),
    fieldName: 'asset_assessability',
    filterOptionsType: FILTER_OPTIONS_TYPE.STATIC,
    fieldValueToFilterValueMapping: (fieldValue: boolean) =>
      fieldValue ? ASSET_ASSESSABILITY_ID.ASSESSABLE : ASSET_ASSESSABILITY_ID.NOT_ASSESSABLE,

    filterData: {
      filterLabel: FILTER_LABEL.ASSET_ASSESSABILITY,
      placement: FILTER_PLACEMENT.ADDITIONAL,
      filterType: FILTER_TYPE.MULTICHECKBOX,
      triggerType: FILTER_TRIGGER_TYPE.ACCORDEON,
      filterOptions: ASSET_ASSESSABILITY_ITEMS,
    },
  },
  {
    allStaticValues: CAMERA_INSTALLED_ITEMS.map((item) => item.id),
    initialStaticValues: CAMERA_INSTALLED_ITEMS.map((item) => item.id),
    fieldName: 'camera_components',
    filterOptionsType: FILTER_OPTIONS_TYPE.STATIC,
    fieldValueToFilterValueMapping: (fieldValue: any[]) =>
      fieldValue.length ? CAMERA_INSTALLED_ID.CAMERA : CAMERA_INSTALLED_ID.NO_CAMERA,
    filterData: {
      filterLabel: FILTER_LABEL.CAMERA_INSTALLED,
      placement: FILTER_PLACEMENT.ADDITIONAL,
      filterType: FILTER_TYPE.MULTICHECKBOX,
      triggerType: FILTER_TRIGGER_TYPE.ACCORDEON,
      filterOptions: CAMERA_INSTALLED_ITEMS,
    },
  },
  {
    allStaticValues: [],
    initialStaticValues: [],
    fieldName: 'asset_type',
    fieldValueToFilterValueMapping: (fieldValue: string) => fieldValue,
    filterOptionsType: FILTER_OPTIONS_TYPE.DYNAMIC,
    filterData: {
      filterLabel: FILTER_LABEL.ASSET_TYPE,
      placement: FILTER_PLACEMENT.QUICK,
      filterType: FILTER_TYPE.MULTICHECKBOX,
      triggerType: FILTER_TRIGGER_TYPE.BUTTON,
      triggerProps: {
        variant: 'outline',
        size: 'default',
      },
      filterOptions: [],
    },
  },
  {
    allStaticValues: [],
    initialStaticValues: [],
    fieldName: 'asset_area',
    fieldValueToFilterValueMapping: (fieldValue: string) => fieldValue,
    filterOptionsType: FILTER_OPTIONS_TYPE.DYNAMIC,
    filterData: {
      filterLabel: FILTER_LABEL.ASSET_AREA,
      placement: FILTER_PLACEMENT.QUICK,
      filterType: FILTER_TYPE.MULTICHECKBOX,
      triggerType: FILTER_TRIGGER_TYPE.BUTTON,
      triggerProps: {
        variant: 'outline',
        size: 'default',
      },
      filterOptions: [],
    },
  },
];
